<template>
<div class="bdialog">
  <el-card :style="'width:230px;margin-right: 2px;height:'+hh3+'px;'" shadow="never">
    <div slot="header" style="text-align:left">
      <span><i class="el-icon-user"></i>个人信息</span>
    </div>
    <div class="bcontent">
      <div>姓名：{{item.SSNAME}}</div>
      <div>班级：{{item.SCNAME}}</div>
      <div>院校：{{item.SNAME}}</div>
      <div>专业：{{item.MNAME}}</div>
      <div>选题：{{item.SSTITLE}} <i v-if="edited" class="el-icon-edit" style="padding-left:5px;cursor:pointer;font-size:16px;" @click="edittitle()"></i></div>
    </div>
  </el-card>
  <div v-if="edited" class="editbar">
        <filedialogbutton :par="pars" :TNAME="''" :okupload="getworks"></filedialogbutton>
      </div>
  <div style="width:100%;height:100%;border:1px solid #EBEEF5;">
    
    <el-tabs type="card" style="padding:0px;" v-model="currenttab1">
      <el-tab-pane :label="pitem.ZJCLASS"  :name="pitem.ZJCLASS" v-for="(pitem,index) in listworks" :key="index" :style="'height:' + hh2 + 'px;overflow:auto;'">
        <fileview :item="citem" v-for="(citem,cindex) in pitem.children" :key="cindex" :hh="hh2">
          <template v-if="pitem.ZJCLASS!='任务书' && edited" slot="editbar">
              <div  style="display:flex;">                
                <el-button type="text" @click="edit(citem)" style="color: green" icon="el-icon-edit">修改文件名称</el-button>
                <el-button type="text" @click="del(citem, cindex)" :disabled="citem.paperguid && !citem.paperviewurl ? true: false" style="color: red" icon="el-icon-close">删除当前文件</el-button>       
                
                <el-dropdown style="color: #790404;font-weight: bold;font-size: 16px;margin: 10px;" @command="headerCommand"  v-if="CU.cu.cc == '1' && CU.cu.zjcc.includes(pitem.ZJCLASS)">
                  <span style="cursor: pointer;">
                    <i class="el-icon-search"></i>查重检测<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="wp">
                      <el-button type="text" v-if="getfinish(citem,'wp')" @click="ccstate(citem,cindex,'wp')" style="color: #790404;font-weight: bold;font-size: 16px;" icon="el-icon-loading">维普检测中...</el-button>
                      <el-button type="text" v-else @click="ccgo(citem,cindex,'wp')" style="color:#790404;font-weight: bold;font-size: 16px;" icon="el-icon-search">维普查重</el-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="xn">
                      <el-button type="text" v-if="getfinish(citem,'xn')" @click="ccstate(citem,cindex,'xn')" style="color: #790404;font-weight: bold;font-size: 16px;" icon="el-icon-loading">校内检测中...</el-button>
                      <el-button type="text" v-else @click="ccgo(citem,cindex,'xn')" style="color:#790404;font-weight: bold;font-size: 16px;" icon="el-icon-search">校内查重</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
          </template>
        </fileview>
      </el-tab-pane>
      <!-- <el-tab-pane label="查重报告" v-if="item.paperviewurl"  :style="'height:' + hh2 + 'px;overflow:auto;'">
          <iframe :src="item.paperviewurl" :style="'height:'+hh2+'px;width:100%;'"></iframe>
      </el-tab-pane> -->
      <el-tab-pane label="周志" name="周志" v-if="weekloglist.length>0" key="周志" :style="'height:' + hh2 + 'px;overflow:auto;'">
        <el-timeline>
          <el-timeline-item placement="top" v-for="(item,index) in weekloglist" :key="index" >
            <el-card shadow="hover">
              <div style="padding:3px;display: flex;flex-direction:row;align-items: center;justify-content:space-between;">
                <div>{{item.CDATE}}:{{item.LOGTYPE}}</div>
              </div>
              <div style="padding:3px;" v-html="item.LOGCONTENT.replace(/\n/g,'<br />')"></div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
      <el-tab-pane label="指导记录" name="指导记录"  v-if="loglist.length>0" key="指导记录" :style="'height:' + hh2 + 'px;overflow:auto;'">
        <el-timeline>
          <el-timeline-item :timestamp="item.CDATE+'>'+item.UNAME" placement="top" v-for="(item,index) in loglist" :key="index" >
            <el-card shadow="hover">
              <div><span style="color:red;">{{item.LOGTYPE}}</span><span>{{item.ZJCLASS}}</span></div>
              <div style="padding:3px;" v-html="item.LOGCONTENT.replace(/\n/g,'<br />')"></div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
    </el-tabs>
  </div>
  <el-dialog title="查重检测" :visible.sync="dialogFormWeekVisible1" width="500px" append-to-body>
    <div>
      <div v-if="cc<ccmax">
        <p>系统只给每位学生提供<span style="color:red;font-weight: bold;">{{ccmax}}</span>次查重额度，当前已经使用<span style="color:red;font-weight: bold;">{{cc}}</span>次!</p>
        <p>确定继续提交检测吗？</p>
      </div>
      <div v-else>
        每位学生系统只提供{{ccmax}}次查重额度，当前已经超出额度，请点击此链接<a :href="ccgr" target="_blank">自主检测</a>。
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <querytitle>
        <template slot="queryleft">
          <el-link :href="ccgr" target="_blank" type="success" v-if="cc<ccmax">先自主检测</el-link>
        </template>
        <template slot="queryright">
          <el-button @click="dialogFormWeekVisible1=false">取 消</el-button>
          <el-button type="primary" @click="ccsummit()"  v-if="cc<ccmax">确 定</el-button>
        </template>
      </querytitle>
      
    </div>
  </el-dialog>
</div>
</template>

<script>
import querytitle from "@/components/querytitle";
import fileview from '@/components/fileview'
import filedialogbutton from '@/components/filedialogbutton'
export default {
  components: {
    querytitle,
    fileview,
    filedialogbutton
  },
  props: {
    item: {
      type: Object,
      default: {
        SSID: "",
        SSNAME: '',
        SCNAME:'',
        MNAME:'',
        SSTITLE:''
      },
    },
    hh: {
      type: Number,
      default: 500,
    },
    edited:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    item(to, from) {
      this.pars.SID=to.SID
      this.pars.SSID = to.SSID
      this.getworks()      
      this.getlogs()
      this.getweeklogs()
    },
    hh(to, from) {
      this.hh2 = to;
      this.hh3 = to+60;
    }
  },
  data() {
    return {
      hh2: 480,
      hh3: 450,
      listworks: [],
      weekloglist:[],
      loglist:[],
      pars:{objname:'zj_works',ZJS:['老师指导记录','查重报告','其它'],SID:'',SSID:''},
      currenttab1:'任务书',
      dialogFormWeekVisible1:false,
      itemlist: [],
      itemedit:{},
      itemeditindex:0,
    }
  },
  mounted() {
    this.hh2 = this.hh ;
    this.hh3 = this.hh+60 ;
    if(this.edited){
      this.getzjs()
    }
    this.getworks()
    this.getweeklogs()
    this.getlogs()
    this.pars.SID=this.item.SID
    this.pars.SSID = this.item.SSID
  },
  methods: {
    getfinish(item,ccfs){//是否查重中
      if(ccfs == 'wp' && item.paperguid ){
        if(!item.paperviewurl)
          return true;
        else
          return false;
      }
      if(ccfs == 'xn' && item.dataid){
          if(!item.paperviewurlxn)
            return true;
          else
            return false
      }
      return false;
    },
    getzjs(){
      let that = this
      that.GetData('GetZJS',{SID:that.CU.cu.sid},function(res){
        that.pars.ZJS = res.data.ZJS;
      },function(err){

      })
    },
    getworks(res1) {
      const that = this
      if(res1){
        that.currenttab1 = res1.data.fileinfo.ZJCLASS
      }
      that.listworks =[]
      that.PostData(
        "Common/GetOtherMethod", {
          "methodname": "GetWorksList",
          "pars": {
            "SSID": that.item.SSID
          }
        },
        function (res) {
          that.listworks = res.data.data
          if(that.listworks.length>0 && !res1){
            that.currenttab1 = that.listworks[0].ZJCLASS;
          }
        },
        function (err) {
          console.log(err)
        }
      )
    },
    getweeklogs(){
      const that = this
      let pars = {
        objname: "zj_works_log",
        wheres: [{
          field: 'SSID',
          sym: '=',
          val: that.item.SSID,
          oper: 'and'
        },{
          field: 'ZJCLASS',
          sym: '=',
          val: '周志',
          oper: ''
        }]
      }
      that.PostData("Common/GETLIST", pars,
        function (res) {
          that.weekloglist = res.data.data;
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    getlogs() {
      const that = this
      let pars = {
        objname: "zj_works_log",
        wheres: [{
          field: 'SSID',
          sym: '=',
          val: that.item.SSID,
          oper: 'and'
        },{
          field: 'LOGTYPE',
          sym: 'like',
          val: '审阅%成果',
          oper: ''
        }]
      }
      that.PostData("Common/GETLIST", pars,
        function (res) {
          that.loglist = res.data.data;
        },
        function (err) {
          that.$alert(err, {
            title: "错误"
          });
        }
      );
    },
    edit(par) {
      const that = this;
      this.$prompt("文件名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /'*/,
          inputPlaceholder: "请输入文件名称",
          inputValue: par.FILENAME,
          inputErrorMessage: "请输入文件名称",
        })
        .then(({
          value
        }) => {
          let pars = {
            objname: "zj_works",
            model: {
              ZWID: par.ZWID,
              FILENAME: value
            },
          };
          that.PostData(
            "Common/EDIT",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              par.FILENAME = value;
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {});
    },
    edittitle(){
      const that = this
      this.$prompt('修改选题名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue:that.item.SSTITLE
        }).then(({ value }) => {
          that.GetData('QUERY/EDITTITLE',{SSID:that.item.SSID,SSTITLE:value},function(res){
            if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
            }
            that.item.SSTITLE = value
          },function(err){
            that.$alert(err, {
              title: "错误",
              type:"error"
            });
          })
          
        }).catch(() => {
        });
    },
    del(item, index) {
      const that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let pars = {
            objname: "zj_works",
            model: {
              ZWID: item.ZWID,
              FILEPATH: item.FILEPATH
            },
          };
          that.PostData(
            "Common/DEL",
            pars,
            function (res) {
              if (res.data.error_code != 0) {
                that.$alert(res.data.message, {
                  title: "错误"
                });
                return;
              }
              that.getworks()
            },
            function (err) {
              console.log(err);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    ccgo(item, index,ccfs) {
      let that = this
      if(!that.item.SSTITLE){
        that.$alert('选题为空，无法继续！', {
          title: "错误"
        });
        return;
      }
      that.itemedit = item;
      that.itemeditindex = index;
      if(ccfs == 'wp'){
        that.GetData('CCAutoLogin', { zwid: item.ZWID }, function (res) {
          console.log(res)
          that.ccgr = res.data.data;
          that.cc = res.data.cc*1;
          that.ccmax = res.data.ccmax*1;
          that.dialogFormWeekVisible1 = true;
        }, function (err) {
          that.$message({
                message: err,
                type: 'warning'
              });
        })
      }
      if(ccfs == 'xn'){
        that.$confirm("确定提交作品去校内查重吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.itemedit.dataid = "正在检测..."
          that.$set(that.listworks, that.itemeditindex, that.itemedit)    
          that.dialogFormWeekVisible1=false
          that.GetData('CCXNPapersubmit',{zwid:that.itemedit.ZWID},function(res){
            console.log(res)
            if(!res.data.paperid){        
              that.getworks();
            }
          },function(err){
            that.$message({
              message: err,
              type: 'warning'
            });
          })
        }).catch(()=>{})
      }
    },
    ccstate(item, index,ccfs){
      // let that = this
      // that.itemedit = item;
      // that.itemeditindex = index;
      // that.GetData('CCPaperList', { paperids: item.paperid }, function (res) {
      //   if(res.data.data == '2'){
      //     that.getworks();
      //   }else{
      //     that.$alert(res.data.message, '提示', {
      //       dangerouslyUseHTMLString: true
      //     });
      //     if(res.data.data == '3')
      //       that.getworks();
      //   }
      // }, function (err) {
      //   that.$message({
      //         message: err,
      //         type: 'warning'
      //       });
      // })
      let that = this
      that.itemedit = item;
      that.itemeditindex = index;
      if (ccfs == 'wp')
        if (item.paperid) {
          that.GetData('CCPaperList', { paperids: item.paperid }, function (res) {
            if (res.data.data == '2') {
              that.getworks();
            } else {
              that.$alert(res.data.message, '提示', {
                dangerouslyUseHTMLString: true
              });
              if (res.data.data == '3')
                that.getworks();
            }

          }, function (err) {
            that.$message({
              message: err,
              type: 'warning'
            });
          })
        }
      if (ccfs == 'xn')
        if (item.dataid) {
          that.GetData('CCPaperXNList', { dataid: item.dataid }, function (res) {
            if (res.data.data == '2') {
              that.getworks();
            } else {
              that.$alert(res.data.message, '提示（校内）', {
                dangerouslyUseHTMLString: true
              });
              if (res.data.data == '3')
                that.getworks();
            }
          }, function (err) {
            that.$message({
              message: err + '（校内）',
              type: 'warning'
            });
          })
        }
    },
    ccsummit(){
      let that = this
      this.$confirm("确定提交作品去维普查重吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.cc +=1;
          that.itemedit.paperguid = "正在检测..."
          that.$set(that.listworks, that.itemeditindex, that.itemedit)    
          that.dialogFormWeekVisible1=false
          that.GetData('CCPapersubmit',{zwid:that.itemedit.ZWID},function(res){
            console.log(res)
            if(!res.data.paperid){        
              that.getworks();
            }
          },function(err){
            that.$message({
              message: err,
              type: 'warning'
            });
          })
        }).catch(()=>{})
    },
  }
}
</script>

<style>
.editbar{
  position:fixed;
  top:60px;
  right:20px;
  z-index: 9999;
}
.bdialog {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btitle {
  background-color: #f0f0f0;
  font-weight: bold;
  line-height: 35px;
  text-align: left;
  border: 1px solid #ccc;
  padding: 3px;
}

.bcontent {
  text-align: left;
  padding: 3px;
  line-height: 35px;
}
</style>
